import { ButtonLink } from '@designsforhealth/dfh-react-components'
import { Slider as MuiSlider, withStyles } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

import Background from '../../../img/rewards/dfh-slider-logo.svg'

const DfhThumb = styled('div')({
  width: '33px',
  height: '33px',
  backgroundImage: `url(${Background})`,
  backgroundSize: 'cover',
  position: 'relative',
  marginTop: '-10px',
  marginLeft: '-17px',
  cursor: 'pointer',
  '&:hover, &:focus, &.MuiSlider-thumb': {
    boxShadow: 'none',
  },
})

const Container = styled.div<{ $maxApplied: boolean }>`
  display: flex;
  flex-wrap: wrap;
`

const Slider = withStyles((theme) => ({
  root: {
    height: 14,
    padding: '20px 0 5px 0',
    // leave room on each side for thumb
    margin: '0 18px 0 16px',
  },
  track: {
    height: 14,
    borderRadius: 50,
    backgroundColor: theme.nonMuiTheme.colors.brandBlue.main,
  },
  rail: {
    height: 14,
    borderRadius: 50,
    backgroundColor: theme.nonMuiTheme.colors.coolGray.cool200,
  },
}))(MuiSlider)

const StyledButtonLink = styled(ButtonLink)`
  font-size: 12px;
  font-weight: 500;
  font-family: ${({ theme }) => theme.fontFamilies.robotoCondensed};
  color: ${({ theme }) => theme.colors.royalBlue.shade500};
  letter-spacing: 0.06em;
  text-decoration: underline;
  margin-left: auto;
`

export interface RewardsSliderProps {
  disabled: boolean
  maxAmount: number
  maxApplied: boolean
  onApplyMax: () => void
  onChange: (event: React.ChangeEvent<object>, value: number | number[]) => void
  onChangeCommitted: (event: React.ChangeEvent<object>, value: number | number[]) => void
  value: number
}

export const ApplyRewardsSlider: React.FC<RewardsSliderProps> = ({
  disabled,
  maxAmount,
  maxApplied,
  onApplyMax,
  onChange,
  onChangeCommitted,
  value,
}) => {
  return (
    <Container $maxApplied={maxApplied}>
      <Slider
        defaultValue={0}
        min={0}
        max={maxAmount}
        onChange={onChange}
        onChangeCommitted={onChangeCommitted}
        step={1}
        ThumbComponent={DfhThumb}
        value={value}
      />
      {!maxApplied && (
        <StyledButtonLink onClick={onApplyMax} disabled={disabled}>
          Apply Max
        </StyledButtonLink>
      )}
    </Container>
  )
}

export default ApplyRewardsSlider
